import {
  FAVORITE_CLIENT,
  FAVORITE_CLIENT_SUCCESS,
  FAVORITE_CLIENT_ERROR,
  LOAD_CLIENTS,
  LOAD_CLIENTS_ERROR,
  LOAD_CLIENTS_SUCCESS,
  UPDATE_CLIENT,
  UPLOAD_CLIENTS,
  UPDATE_STATE_CLIENT,
  VERIFY_RISK_CLIENT,
} from '../constants/clients';

export const FavoriteClient = payload => ({
  type: FAVORITE_CLIENT,
  payload,
});

export const FavoriteClientSuccess = payload => ({
  type: FAVORITE_CLIENT_SUCCESS,
  payload,
});

export const FavoriteClientError = payload => ({
  type: FAVORITE_CLIENT_ERROR,
  payload,
});

export const LoadClients = ({ payload, clientsSelected, operationId }) => ({
  type: LOAD_CLIENTS,
  payload,
  clientsSelected,
  operationId,
});

export const LoadClientsSuccess = payload => ({
  type: LOAD_CLIENTS_SUCCESS,
  payload,
});

export const LoadClientsError = payload => ({
  type: LOAD_CLIENTS_ERROR,
  payload,
});

export const UpdateClient = ({ payload, operationId }) => ({
  type: UPDATE_CLIENT,
  payload,
  operationId,
});

export const VerifyRisk = payload => ({
  type: VERIFY_RISK_CLIENT,
  payload,
});

export const UpdateStateClient = payload => ({
  type: UPDATE_STATE_CLIENT,
  payload,
});

export const UploadClients = ({clients, operationId}) => ({
  type: UPLOAD_CLIENTS,
  clients,
  operationId,
});
